import styled from 'styled-components';
import { List } from 'antd';

export const StyledList = styled(List)`
  .ant-list-item {
    padding: 5px 0;
  }
`
export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  background-color: #F7F7FC;
  border-radius: 3px;
`

export const LeftDiv = styled.div`
 display: flex;
 flex-direction: column;
 flex: 1;
 margin-right: 3px;
 padding: 5px 10px;
`;

export const RightDiv = styled.div`
  display: flex;
  align-items: center;
  padding: 5px 10px;
  background: #F1F1F1;
  border-radius: 3px;
  flex-direction: column;
  justify-content: center;
`;

export const CauseWrap = styled.div`
 display: flex;
 flex-direction: row;
 flex-wrap: wrap;
 border-bottom: 1px solid #DADADA;
 cursor: pointer;
 font-size: 1em;
 color: #4080E2;
 text-overflow: ellipsis;
 width: 100%;
 overflow: hidden;
 white-space: nowrap;
 &:hover {
  color: #0945A2;
  }
`;

export const CauseText = styled.div`
  border-right: 1px solid #DADADA;
  margin-bottom: 3px;
  padding: 0px 5px;
  width: 268px;
  text-overflow: ellipsis;
  overflow: hidden;

&:last-child {
  border-right: 0px;
}
&:first-child {
  padding-left:0px;
}
`;

export const SubText = styled.div`
 color: rgb(134, 134, 134);
 font-size: 1em;
`;

export const SubMetricText = styled.div`
  padding-right: 5px;
  margin-top: 4px;
  float: left;
`;

export const SubImpactedText = styled.div`
  float: left;
  padding: 0px 5px 0px 10px;
  margin-top: 4px;
  margin-left: 5px;
  border-left: 1px solid #DADADA;
`;
